import axios from "axios";

const state = () => ({
  models360: [],
});

const getters = {
  getModel360Imgs: (state) => (id, type) => {
    let res = state.models360.find((el) => el.modelID == id);
    if (type == 1) return res.colors?.[0].externalColorImages360;
    return res.colors;
  },
  get360ImgByVersion: (state) => (id, v) => {
    let findEl = state.models360.find((el) => el.modelID == id);
    let res = findEl.colors?.filter((el) => el.version == v);
    return res ? res : null;
  },
  getUserSelectedImg: (state) => (id, v, colID) => {
    if (colID == undefined) return false;
    let findModel = state.models360.find((el) => el.modelID == id);
    let res = findModel.colors.find(
      (el) => el.id == colID && el.version == v
    )?.externalColorImages360;
    return res;
  },
  modelHasColors: (state) => (id) => {
    let exists = state.models360.some((el) => el.modelID == id);
    if (exists) return true;
    return false;
  },
  getGallery: (state, getters, rootState, rootGetters) => (idModel, idvc) => {
    const data = state.models360.find((el) => el.modelID == idModel);
    const colorsIDs = data.colors.map(({ id, version }) => ({ id, version }));

    const getDefaultArr = () => [rootGetters.getModelById(idModel).modelImg];
    const getColorImage = (id) =>
      data.colors?.find((el) => el.id === id)?.externalColorImages360?.[0] ||
      getDefaultArr();

    if (!colorsIDs?.length) return getDefaultArr();

    const flat = (
      idvc ? colorsIDs.filter((el) => el.version === idvc) : colorsIDs
    ).flatMap((el) => el.id);

    const res = data.gallery
      .filter((el) => flat.includes(el.idColor))
      .flatMap((el) => el.image);

    return res?.length ? res : [getColorImage(flat[0])];
  },
};

const mutations = {
  SET_MODEL_IMGS(state, payload) {
    if (state.models360.some((el) => el.modelID == payload.modelID)) return;
    state.models360.push(payload);
  },
};

const actions = {
  fetch360Model({ commit, getters }, id) {
    if (getters.modelHasColors(id)) return;

    const hyu = process.env.VUE_APP_HYU;
    let url = hyu + process.env.VUE_APP_API_EXTCOLORS + id;

    // const modelsHeader = {
    //     'Content-Type': 'application/json',
    //     'AccessToken': process.env.VUE_APP_MODELSTOKEN,
    // }

    // axios.get(url, { headers: modelsHeader } )
    axios
      .get(url)
      .then((res) => {
        let arr =
          res.data.length == 0 ? { modelID: id, colors: null } : res.data;
        commit("SET_MODEL_IMGS", arr);
      })
      .catch((err) => console.log(err));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
